var angular = require('angular');
import licenseModule from '../../license.module';

export default licenseModule.component('licenseServerProfile', {
    template: require('./licenseServerProfile.component.html'),
    controller: ['LicenseManagementService', licenseServerProfileComponent],
    bindings: {
        id: '<',
        close: '&',
        dismiss: '&',
        callback: '&'
    }
});

function licenseServerProfileComponent(LicenseManagementService) {
    var vm = this;
    vm.elements = [];
    vm.$onInit = renderChanges;
    vm.$onChanges = renderChanges;

    function renderChanges() {
        if (vm.id != undefined) {
            LicenseManagementService.getInstanceDetail(vm.id).then(function(
                data
            ) {
                vm.elements = [];
                angular.forEach(data.attributes, function(value, key) {
                    var serverProfileAttribute = value.key;
                    var serverProfileValue = value.value;
                    var serverProfileItem = {
                        no: key + 1,
                        attribute: serverProfileAttribute,
                        value: serverProfileValue
                    };
                    vm.elements.push(serverProfileItem);
                });

                LicenseManagementService.get64CharPayload(data.payload).then(
                    function(data) {
                        vm.serverProfilePayload = data;
                        vm.hidecopybutton = false;
                    },
                    function() {
                        vm.serverProfilePayload =
                            'Failed to retrieve Server Profile. Please try again. If the problem persists, please contact Appspace Support.';
                        vm.hidecopybutton = true;
                    }
                );
                vm.callback({ value: data.payload });
            });
        }

        vm.table = {
            options: {
                paging: {
                    itemsPerPage: 5
                },
                sortable: false,
                showHeader: true,
                startRows: 1,
                columns: [
                    {
                        name: 'no',
                        label: ''
                    },
                    {
                        name: 'attribute',
                        label: 'Attribute'
                    },
                    {
                        name: 'value',
                        label: 'Value'
                    }
                ]
            }
        };
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-server-profile/licenseServerProfile.component.js